
const URL = {
  identity: {
    login: '/api/identity/login',
    validateOTL: 'api/identity/validate-otl',
    triggerOTP: 'api/identity/trigger-otp',
    validateOTP: 'api/identity/validate-otp',
    alive: '/api/identity/alive',
  },
  bff: {
    UserPortfolioTeamCodes: `/api/bff/user/portfolio`,
    getReportsList:'/api/bff/reports',
    getDownloadReport:(id: string) => `/api/bff/report/${id}`,
    getCashAccountsData: '/api/bff/deposits/retrieve-cash-account',
    getLoanAccountsData: '/api/bff/loans/retrieve-loan-account',
    saveCashAccountsMapping: '/api/bff/deposits/mapping',
    saveLoanAccountsMapping: '/api/bff/loans/mapping',
    getUserEntitiesNJourneys: '/api/bff/user/journeys',
    triggerInvite: '/api/bff/invite',
    triggerPortalInvite: '/api/bff/portal-invite',
    triggerCompleteRegistrationInvite: '/api/bff/complete-registration/invite',
    getUserJourneyTasks: (journeyId) => `/api/bff/user/journey/${journeyId}/tasks`,
    verifyEntity: (entityId) => `/api/bff/verify-prospect-data/${entityId}`,
    uploadDocument: '/api/bff/verifyPartyDocument',
    updateIdvStatus: (entityId, entityDraftId) => `/api/bff/update-idv-status/${entityId}/draft/${entityDraftId}`,
    updateProspectIdvDocs: (entityId) => `/api/bff/update-prospect-idv-docs/${entityId}`,
    verifyIndividual: (entityId, entityDraftId) => `/api/bff/verify-individual/${entityId}/draft/${entityDraftId}`,
    submitApplication: '/api/bff/submit-application',
    getDocusignRecipientStatus: (entityDraftSourceEntityId) => `/api/bff/docusign/envelopes/${entityDraftSourceEntityId}/recipient-status`,
    getDocusignRecipientViewURL: `/api/bff/docusign/envelopes/returnUrl`,
    getUserInfo: '/api/bff/user-info',
    I2CUpdate: '/api/bff/i2c/update',
    dataGroups: '/api/bff/data-group',
    inviteCollaborator: '/api/bff/invite-collaborator',
    fetchCollaborators: journeyId =>  `/api/bff/get-collaborators?journeyId=${journeyId}`,
    deleteCollaborator: (associationId: string, journeyId: string) => `/api/bff/delete-collaborator/${journeyId}/association/${associationId}`,
    getCompanies: `/api/bff/companies`,
    getCompaniesWithQuerySearch:(value: string) => `/api/bff/companies?query=${encodeURIComponent(value)}`,
    getWatchlistCompanies: `/api/bff/company/watchlist`,
    allSvbers: `/api/bff/allSvbers`,
    getCompanyDetails:(companyId)=>`/api/bff/get-company/${companyId}`,
    addCompanyDetails: `/api/bff/add-company`,
    updateCompanyDetails: `/api/bff/update-company`,
    getWorkbookRecords: (companyId) => `/api/bff/get-workbook-records/${companyId}`,
    getTimelineRecords: (companyId) => `/api/bff/timeline-events/${companyId}`,
    downloadWorkbook: (bucket, key) => `/api/bff/download-workbook?bucket=${bucket}&key=${key}`,
    toggleCompanyHiddenStatus:  `/api/bff/show-hide-company`,
    fireWorkbookRefresh:'/api/bff/fire-workbook-refresh',
    updatePersonalDetails: '/api/bff/contact-info',
    getAccountMappings:(companyId)=>`/api/bff/borrower-account-mappings/${companyId}`,
    updateBorrowerAccountMappingsForRefresh:'/api/bff/update-borrower-account-mappings-for-refresh',
    saveBucketing: '/api/bff/save-bucketing',
    sendWorkbookToExternalSystem: '/api/bff/send-workbook-to-system',
    addDashboardUsers: '/api/bff/add-dashboard-user',
    updateUserByEmail: '/api/bff/user',
    notifyPrimaryContact: '/api/bff/notify-primary-contact',
    reNotifyCSContact: '/api/bff/renotify-cs-contact',
    updateDepositAccountsMappingStatus: '/api/bff/deposits/mapping-status',
    digitalLoanApp: '/api/bff/digital-loan-app',
    getRestatementSummary: (companyId: string) => `/api/bff/restatement-monitor/${companyId}`,
    getRestatementSummaryPFSAndPL: (companyId: string) => `/api/bff/restatement-monitor-pfs-and-pl/${companyId}`,
    updateLoanAccountsMappingStatus: '/api/bff/loans/mapping-status',
    adfTrackingApp: '/api/bff/adf-apps',
    adfAppsInternal: '/api/bff/adf-apps/internal',
    getBookClosureCompanies: '/api/bff/book-closure-report',
    getActionRequiredCompanies: '/api/bff/disconnection-management/action-required',
    getActionedCompanies: '/api/bff/disconnection-management/actioned',
    updateDisconnectMgmtStatus:'/api/bff/disconnection-management/status',
    getRestatementStatus: '/api/bff/restatement-status',
    getCreditlensCategoryRollup: '/api/bff/creditlens-category-rollup',
    getPdsEligibility: `/api/bff/get-pds-eligibility`,
    getServerSideEvents: (codatCompanyId:string, moduleNames: string[]) => `/api/bff/events?codatCompanyId=${codatCompanyId}&moduleNames=${encodeURIComponent(moduleNames.join(","))}`
  },
  codat: {
    getCodatCompanies: '/api/codat/all-companies',
  },
  accounting: {
    basePath: '/api/codat',
    createConnection: (companyId)  => `/api/codat/companies/${companyId}/connections`,
    getAllIntegrations: '/api/codat/integrations',
    getCompanyId: '/api/codat/companies',
    getI2CCompanyId: (i2cId) => `/api/codat/i2c-companies/${i2cId}`,
    getCompany: (companyId) => `/api/codat/companies/${companyId}`,
    createCompany: '/api/codat/companies',
    deleteConnection: (companyId, connectionId) => `/api/codat/companies/${companyId}/connections/${connectionId}` 
  },
  fenergo: {
    basePath: '/api/fenergo/',
    uploadBasePath: '/api/fenergo/upload/',
    uploadBasePathV2: '/api/fenergo/upload/v2/',
    uploadBasePathV3: '/api/fenergo/upload/v3/',  
    status: '/api/fenergo/status',
    // lookup domain
    getLookups: `lookupquery/api/lookup/active`,
    getLookupLinks: `lookupquery/api/lookuplink/active`,
    // policy domain
    evaluatePolicyEngineCapTable: `/policyquery/api/requirements-in-scope`,
    getRequirementsInScope: `policyquery/api/v2/requirements-in-scope`,
    evaluateRequirementsInScope: `policyquery/api/v2/requirements-in-scope/evaluate`,
    evaluatePolicyEngine: `policylogicengine/api/v2/engine/evaluate-requirements`,
    evaluatePolicyEngineDataGroup: `policylogicengine/api/engine/evaluate-data-group-fields`,
    evaluatePolicyEngineSets:
      'policylogicengine/api/v3/engine/evaluate-requirement-sets',
    // entity domain
    getEntityDraftData: (entityId) => `entitydataquery/api/entity/${entityId}/draft`,
    getEntityDraftsList: `entitydataquery/api/drafts-in-scope/searchentitydrafts`,
    updateEntityDraft: (entityId, entityDraftId) => `entitydatacommand/api/v2/entity/${entityId}/draft/${entityDraftId}`,
    getEntityDraftById: (entityId, entityDraftId) => `entitydataquery/api/entity/${entityId}/draft/${entityDraftId}`,
    // association domain
    getAssociations: (entityId, journeyId) => `associationquery/api/association/root/${entityId}/journey/${journeyId}`,
    deleteAssociation: (id, isVerified, journeyId) => `associationcommand/api/association/${id}${isVerified ? `/${journeyId}` : ''}`,
    // document domain
    getEntityDocuments: (entityId) => `documentmanagementquery/api/documentmanagement/entity/${entityId}`,
    getDocumentUrl: (documentId) => `documentmanagementquery/api/documentmanagement/signedurl/${documentId}`,
    uploadDocument: `documentmanagementcommand/api/documentmanagement`,
    uploadDocumentv2: `documentmanagementcommand/api/v2/documentmanagement`,
    uploadDocumentv3: `documentmanagementcommand/api/v3/documentmanagement`,
    removeDoc: (documentId) => `documentmanagementcommand/api/v2/documentmanagement/${documentId}`,
    // journey domain
    completeTaskInJourney: (journeyInstanceId, taskId) => `journeycommand/api/journey-instance/${journeyInstanceId}/task/complete?taskId=${taskId}`,
  },
};
export const FCB_PRIVACY_STATEMENT = 'https://www.firstcitizens.com/privacy-security/privacy-statement';
export const SVB_ECOA_URL = 'https://www.svb.com/equal-credit-opportunity-act-disclosures';
export const TERMS_OF_USE = 'https://www.firstcitizens.com/terms-of-use';


export default URL;
